var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14062 11.875V9.76562H6.25V8.35938H4.14062V6.25H2.73438V8.35938H0.625V9.76562H2.73438V11.875H4.14062Z",
    fill: "#00858A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10C13.6662 10 15.625 8.04125 15.625 5.625C15.625 3.20875 13.6662 1.25 11.25 1.25C8.83375 1.25 6.875 3.20875 6.875 5.625C6.875 8.04125 8.83375 10 11.25 10Z",
    fill: "#00858A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25C8.53828 11.25 3.125 12.925 3.125 16.25V18.75H19.375V16.25C19.375 12.925 13.9617 11.25 11.25 11.25Z",
    fill: "#00858A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.f04b2def2e146f43e58c4ff3fc28d60c.svg";
export { ForwardRef as ReactComponent };